export default __webpack_public_path__ + "static/media/about_text_ru.997443c3.png";